import { render, staticRenderFns } from "./banner-pc.vue?vue&type=template&id=8bbdc1f4&scoped=true&"
var script = {}
import style0 from "./banner-pc.vue?vue&type=style&index=0&id=8bbdc1f4&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bbdc1f4",
  null
  
)

export default component.exports